(function () {
    const SID_STORAGE_KEY = 'sid_tracking';
    const DAYS_VALID = 15;

    function now() {
        return Date.now();
    }

    function getExpiresAt() {
        return now() + DAYS_VALID * 24 * 60 * 60 * 1000;
    }

    function saveSid(sid) {
        const data = {
            sid: sid,
            expiresAt: getExpiresAt(),
        };
        localStorage.setItem(SID_STORAGE_KEY, JSON.stringify(data));
        // console.log('[SID] Guardado/renovado', data);
    }

    function getValidSid() {
        const raw = localStorage.getItem(SID_STORAGE_KEY);
        if (!raw) return null;

        try {
            const data = JSON.parse(raw);
            if (!data.sid || !data.expiresAt) {
                localStorage.removeItem(SID_STORAGE_KEY);
                return null;
            }

            // Si venció, lo borramos
            if (now() > data.expiresAt) {
                localStorage.removeItem(SID_STORAGE_KEY);
                // console.log('[SID] Expirado, eliminado');
                return null;
            }

            return data.sid;
        } catch (e) {
            localStorage.removeItem(SID_STORAGE_KEY);
            return null;
        }
    }

    function readSidFromUrl() {
        const url = new URL(window.location.href);

        // 1. Buscar en query string ?sid=...
        let sid = url.searchParams.get('sid') || url.searchParams.get('SID');

        // 2. Si no está en query, buscar en el hash #sid=...
        if (!sid && url.hash) {
            const hash = url.hash.substring(1); // sin '#'
            const hashParams = new URLSearchParams(hash);
            sid = hashParams.get('sid') || hashParams.get('SID');
        }

        return sid;
    }

    function initSidTracking() {
        const incomingSid = readSidFromUrl();

        if (incomingSid) {
            // Si viene un SID nuevo en el link, siempre renovamos a +15 días.
            saveSid(incomingSid);
        } else {
            // Si no viene en la URL, solo validar si el guardado sigue siendo válido.
            getValidSid();
        }
    }

    // Ejecutar al cargar la página
    initSidTracking();

    // Exponer una función global para que Shopify/tu script de checkout pueda leerlo
    window.getSidForTracking = function () {
        return getValidSid(); // úsalo al crear la orden / enviar a tu ERP
    };
})();